module.exports = __webpack_public_path__ + "img/equip-pic5.f1a89afe.png";